import React from "react";

import { toCropDropdownOptions, useCropList } from "~/admin/setup/customer/use-crop-list";
import {
    computeIsSelectable,
    useLoggedInUserProductScopeOrgLevelGuid,
} from "~/admin/setup/customer/use-product-list";

import AddEditPanelContainer from "../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, service, dropdowns, model } from "../data";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    service,
    dropdowns,
});

// prepareSelectableOptions (admin/utils.ts) only carries a source item's own `isSelectable` through
// into `value.isSelectable` -- stamp it here so the crop SelectInput downstream can key
// optionIsHiddenKey off IS_SELECTABLE.
const toSelectableCropDropdownOptions = (crops) =>
    toCropDropdownOptions(crops).map((crop) => ({
        ...crop,
        isSelectable: computeIsSelectable(crop.activeYn, crop.isAgvanceLinked),
    }));

const AddEditContainer = (props) => {
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{ [model.PROPS_CROP_LIST]: toSelectableCropDropdownOptions(crops) }}
        />
    );
};

export default AddEditContainer;
